module.exports = __webpack_public_path__ + "img/companies.424f243.jpg";